import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import Wrapper from '../../../../hoc/Wrapper/Wrapper';

import './WizardProgressBar.scss';
import {
  MODEL_SELECTION_RELEASES,
  MODEL_SELECTION_SELECTED_RELEASE,
  TARGET_SELECTION_SELECTED_TARGET,
  TARGET_SELECTION_TARGETS,
} from '../../../../shared/const/Routes/statePaths';
import { getSafe } from '../../../../shared/utility';
import { useSelector } from 'react-redux';

const TOP_BAR = 'top';

const progressBarItems = [
  { name: 'PROJECT SELECTION', number: 1 },
  { name: 'MODEL SELECTION', number: 2 },
  { name: 'TARGET SELECTION', number: 3 },
  { name: 'TEST CONFIGURATION', number: 4 },
  { name: 'SUMMARY', number: 5 },
];

const releaseNameField = 'ReleaseName';
const targetNameField = 'TargetName';

const WizardProgressBar = props => {
  const { activeStage, selectedSubProject } = props;
  const selectedRelease = useSelector(state =>
    getSafe(MODEL_SELECTION_SELECTED_RELEASE, state)
  );
  const releaseTableData = useSelector(state =>
    getSafe(MODEL_SELECTION_RELEASES, state)
  );
  const selectedTarget = useSelector(state =>
    getSafe(TARGET_SELECTION_SELECTED_TARGET, state)
  );
  const targetData = useSelector(state =>
    getSafe(TARGET_SELECTION_TARGETS, state)
  );
  // const selectedProject = useSelector((state) => getSafe(STATE_PATHS.SELECTED_PROJECT_PATH, state));
  //color depend on isActive
  //previous item different color

  const renderLabel = stageName => {
    switch (stageName) {
      case progressBarItems[0].name: {
        return (
          <label
            className={`progress-stage-label small label-ellipsis
							${stageName === progressBarItems[0].name && selectedSubProject && activeStage > 1 ? '' : 'hidden'}
						`}
            title={
              stageName === progressBarItems[0].name &&
              selectedSubProject &&
              activeStage > 1
                ? selectedSubProject
                : ''
            }
          >
            {stageName === progressBarItems[0].name &&
            selectedSubProject &&
            activeStage > 1
              ? selectedSubProject
              : 'hidden'}
          </label>
        );
      }
      case progressBarItems[1].name: {
        return (
          <label
            className={`progress-stage-label small label-ellipsis
							${stageName === progressBarItems[1].name && selectedRelease != null && activeStage > 2 ? '' : 'hidden'}
						`}
            title={
              stageName === progressBarItems[1].name &&
              selectedRelease != null &&
              activeStage > 2
                ? releaseTableData.find(row => row.id == selectedRelease)[
                    releaseNameField
                  ]
                : ''
            }
          >
            {stageName === progressBarItems[1].name &&
            selectedRelease != null &&
            activeStage > 2
              ? releaseTableData.find(row => row.id == selectedRelease)[
                  releaseNameField
                ]
              : 'hidden'}
          </label>
        );
      }
      case progressBarItems[2].name: {
        return (
          <label
            className={`progress-stage-label small label-ellipsis
							${stageName === progressBarItems[2].name && selectedTarget != null && activeStage > 3 ? '' : 'hidden'}
						`}
            title={
              stageName === progressBarItems[2].name &&
              selectedTarget != null &&
              activeStage > 3
                ? targetData.find(row => row.id == selectedTarget)[
                    targetNameField
                  ]
                : null
            }
          >
            {stageName === progressBarItems[2].name &&
            selectedTarget != null &&
            activeStage > 3
              ? targetData.find(row => row.id == selectedTarget)[
                  targetNameField
                ]
              : 'hidden'}
          </label>
        );
      }
      default: {
        return (
          <label className={`progress-stage-label small hidden`}>
            {'hidden'}
          </label>
        );
      }
    }
  };

  const getStageTemplate = (stageNumber, stageName) => {
    return (
      <div
        key={`${stageNumber}_${stageName}`}
        className={`progress-stage-container ${stageNumber < activeStage ? 'stage-complete' : stageNumber == activeStage ? 'active-stage' : ''}`}
      >
        <div className="progress-bar-active-line" />
        <div className="progress-stage-number">
          {stageNumber < activeStage ? <CheckOutlined /> : stageNumber}
        </div>
        <div className="progress-stage-label-container">
          <label className="progress-stage-label">{stageName}</label>
          {renderLabel(stageName)}
        </div>
      </div>
    );
  };

  // const getSideStageTemplate = (stageNumber, stageName) => {
  // 	const stageLetter = stageNumber === 1 ? 'A' : 'B';
  // 	return (
  // 		<Wrapper key={`${stageNumber}_${stageName}`}>
  // 			{stageNumber > 1 ? <div className={`side-progress-bar-active-line ${stageNumber === activeStage ? 'active-stage' : ''}`} /> : null}
  // 			<div
  // 				className={`side-progress-stage-container ${
  // 					stageNumber < activeStage ? 'stage-complete' : stageNumber == activeStage ? 'active-stage' : ''
  // 				}`}
  // 			>
  // 				<div className="side-progress-bar-active-line2" />
  // 				<div className="side-progress-stage-number">{stageNumber < activeStage ? <CheckOutlined /> : stageLetter}</div>
  // 				<label className="side-progress-stage-label">{stageName}</label>
  // 			</div>
  // 		</Wrapper>
  // 	);
  // };

  const getStages = () => {
    let stages;
    switch (props.type) {
      case TOP_BAR:
        stages = progressBarItems.map(item => {
          return getStageTemplate(item.number, item.name);
        });

        break;
      // case SIDE_BAR:
      // 	stages = sideProgressBarItems.map((item) => {
      // 		return getSideStageTemplate(item.number, item.name);
      // 	});

      // 	break;
      default:
        break;
    }

    return stages;
  };

  return props.isDisplay ? (
    <>
      <div className="progress-bar-area">{getStages()}</div>
      {/* {props.type === SIDE_BAR && <div className="side-progress-bar-area">{getStages()}</div>} */}
    </>
  ) : null;
};

export default WizardProgressBar;
